import { render, staticRenderFns } from "./toolbar-input.vue?vue&type=template&id=dcbf3a28&"
import script from "./toolbar-input.vue?vue&type=script&lang=js&"
export * from "./toolbar-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports